/**
 * Utility
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Feature } from './feature';
import { GeoJSONObjectType } from './geoJSONObjectType';
import { ICRSObject } from './iCRSObject';


export interface FeatureCollection { 
    bbox?: Array<number> | null;
    crs?: ICRSObject;
    type?: GeoJSONObjectType;
    features?: Array<Feature> | null;
}
export namespace FeatureCollection {
}


